// VideoButtons.js
const videoButtons = [
    { label: 'Grateful Juxio', file: 'Grateful Juxio - Fire on the Mountain (dub mix).mp4' },
    { label: 'Cyde of Gypsys', file: 'Cyde of Gypsys - Passing Me By (Fillmore mix).mp4' },
    { label: 'Lost Ones', file: 'Ms. Lauryn Hill - Lost Ones (Shottas mix).mp4' },
    { label: 'Notorious Burke', file: 'Notorious Burke - Juicy (To the Top mix).mp4' },
    { label: 'Flying Fugees', file: 'Flying Fugees - Fu-gee-la Her Story (Solo Lauryn mix).mp4' },
    { label: 'MOS CT3P30', file: 'MOS CT3P30 - Ms. Fat Booty (Funky Russian mix).mp4' },
    { label: 'Gift of Gab RIP', file: 'Gift of Gab RIP - Feel that Way (Kenyatta Remix).mp4' },
    { label: 'Grateful Wu', file: 'Grateful Wu - Da Mystery of Chessboxing (Connecticut mix).mp4' },
    { label: 'Fast Car', file: 'Luke Chapman - Fast Car (Nothing to Prove mix).mp4' },
    { label: 'How High', file: 'Meth, Red & Hammond - How High (Trees for Breakfast mix).mp4' },
    { label: 'Wild for the Night', file: 'Rampage the Last Boyscout ft. Busta Rhymes - Wild for the night (Tapscott Remix).mp4' }
  ];
  console.log(videoButtons);
  export default videoButtons;
  